import { PIMSelect } from './PIMSelect';

export default PIMSelect;
